// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2B6eP","content":"LayoutSettings_content__3yRVj"};